export var EComponentBaseType;
(function (EComponentBaseType) {
    EComponentBaseType["PURE"] = "PURE";
    EComponentBaseType["LUMP"] = "LUMP";
    EComponentBaseType["PSEUDO"] = "PSEUDO";
    EComponentBaseType["HYPOTHETICAL"] = "HYPOTHETICAL";
})(EComponentBaseType || (EComponentBaseType = {}));
export var EComponentsFamilyClass;
(function (EComponentsFamilyClass) {
    EComponentsFamilyClass["ALL"] = "all";
    EComponentsFamilyClass["HYDROCARBONS"] = "hydrocarbons";
    EComponentsFamilyClass["HALOGENS"] = "halogens";
    EComponentsFamilyClass["ALCOHOLS"] = "alcohols";
    EComponentsFamilyClass["ALDEHYDES"] = "aldehydes";
    EComponentsFamilyClass["HYDROCARBON_ACIDS"] = "hydrocarbon_acids";
    EComponentsFamilyClass["KETONES"] = "ketones";
    EComponentsFamilyClass["NON_ORGANIC"] = "non_organic";
    EComponentsFamilyClass["PHENOLS"] = "phenols";
    EComponentsFamilyClass["SULPHUROUS"] = "sulphurous";
    EComponentsFamilyClass["AMINES"] = "amines";
    EComponentsFamilyClass["COMPOUND_ETHER"] = "compound_ether";
    EComponentsFamilyClass["SIMPLE_ETHER"] = "simple_ether";
    EComponentsFamilyClass["NITRILES"] = "nitriles";
    EComponentsFamilyClass["OTHERS"] = "others"; // Прочие
})(EComponentsFamilyClass || (EComponentsFamilyClass = {}));
//# sourceMappingURL=component.enum.js.map